module.exports = __webpack_public_path__ + "static/media/Inventory Optimization.31fe1558.png";